import { AlertType } from '../../enums/AlertType';
import { Alert } from '../../interfaces/Alert';

export const ALERT_EVENT_ADDED_SUCCESS: Alert = {
  type: AlertType.Success,
  title: {
    message: 'Success',
    translate: false,
  },
  message: {
    message: 'alert.custom.event_added',
    translate: true,
  },
};
